import { SETTING_SET_FINANCEFILE_PROPS, REINIT_POSTS_UNAUTHORISED, WIDGET_OPEN } from '../actions/actionsAppTest'
import { REJECT_POSTS_UNAUTHORISED } from '../actions/actionsApi'
import HelperEnv from '../helpers/HelperEnv';

export function env(state, action) {
  switch (action.type) {
    case SETTING_SET_FINANCEFILE_PROPS:
      return { ...state, financeFileProps: { ...action.payload.financeFileProps }, resultStatus: { resHttpStatus: 0 } };
    case REJECT_POSTS_UNAUTHORISED:
      return { ...state, resultStatus: action.payload.status };
    case REINIT_POSTS_UNAUTHORISED:
      return { ...state, resultStatus: { resHttpStatus: 0 } };
    case WIDGET_OPEN:
      if(state.widgetBpfVersion == null){
        const widgetVersion = HelperEnv.retrieveWidgetBPFVersion();
        return { ...state, widgetBpfVersion: widgetVersion }
      }
      return state
    default:
      return state
  }
}
